import { render } from "./ClaimExpenseTypeDropdown.vue?vue&type=template&id=0f9915f4"
import script from "./ClaimExpenseTypeDropdown.vue?vue&type=script&lang=js"
export * from "./ClaimExpenseTypeDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__